import styled from "styled-components";

const EvidenceOptionContainer = styled.div({
    display: "flex",
    gap: "8px",
    width: "100%",
});

export default EvidenceOptionContainer;